import React, { useState, useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { apiPaths, settings } from 'config';
import { getOpenClawStatus } from 'helpers/requests/vms';
import { ax } from 'helpers/requests/axios';

const OpenClawPanel = ({ vmId }) => {
  const [ready, setReady] = useState(false);
  const isMounted = useRef(true);

  const proxyPath = apiPaths.appVms.vms.openclawProxy(vmId);
  const iframeSrc = settings.APIBaseURL + proxyPath.replace(/^\//, '');

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      for (let i = 0; i < 60; i++) {
        if (cancelled) return;
        try {
          // First check if agent status reports running
          const statusResult = await getOpenClawStatus(vmId);
          if (
            statusResult.success &&
            statusResult.response.data.openclaw === 'running'
          ) {
            // Then verify the proxy actually responds (not 502)
            try {
              const proxyResult = await ax.get(
                apiPaths.appVms.vms.openclawProxy(vmId)
              );
              if (proxyResult.status === 200) {
                if (!cancelled && isMounted.current) {
                  setReady(true);
                }
                return;
              }
            } catch (e) {
              // Proxy not ready yet, keep polling
            }
          }
        } catch (e) {
          console.error(e);
        }
        await new Promise(resolve => setTimeout(resolve, 3000));
      }
    };

    poll();
    return () => {
      cancelled = true;
    };
  }, [vmId]);

  if (!ready) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center h-100">
        <Spinner animation="border" className="mb-3" variant="light" />
        <p className="text-muted">Waiting for OpenClaw to start...</p>
      </div>
    );
  }

  return (
    <iframe
      src={iframeSrc}
      style={{
        width: '100%',
        height: '100%',
        border: 'none'
      }}
      title="OpenClaw Control UI"
      allow="clipboard-read; clipboard-write"
    />
  );
};

export default OpenClawPanel;
